export default __webpack_public_path__ + "0a9f966e16e3d1d1f892a3ddbd441911.png";